module.exports = __webpack_public_path__ + "static/images/ui/ui-icons_4b8e0b_256x240.png";